import {common_utils} from "../common/common_utils";
import {joker_utils} from "../joker/joker_utils";
import {game_2002_2004} from "../joker/game_2002_2004";
import {game_2000} from "../joker/game_2000";
import {game_2005} from "../joker/game_2005";
import {game_2001} from "../joker/game_2001";
import {game_3000} from "../esports/game_3000";


function detail_by_token_joker()
{

}

detail_by_token_joker.readDataValue = function(this1, data)
{
      if (this1.getlang == 'zh_cn') {
        this1.img_lang = 'cn'
      } else {
        this1.img_lang = 'zhf'
      }

      this1.joker = true
      common_utils.readDataValue(this1,data,true,true);
      this1.commonpoker = data.detail.CommonPokers
      this1.bankerpoker = data.detail.BankerPokers
      this1.handpoker = data.detail.HandPoker
      this1.isTotalWin= common_utils.getValue(data,"winCny")>0;

      if (data.serverId == 1) {
        this1.ting = this1.$t(`lang.str_custom_ting`)
      } else if (data.serverId == 2) {
        this1.ting = this1.$t(`lang.str_vip_ting`)
      } else if (data.serverId == 3) {
        this1.ting = this1.$t(`lang.str_tuhao_ting`)
      }

      if (data.gameId == 2000) {

        const getwin = data.detail.Win - data.detail.AnteBet - data.detail.FlopBet - data.detail.RiverBet -
          data.detail.TurnBet
        if (getwin > 0) {
          this1.iswinType = this1.$t(`lang.str_iswin`)
        } else {
          // this1.iswinType = this1.$t(`lang.str_isfail`)
        }
        if (data.detail.IsFold) {
          this1.iswinType = this1.$t(`lang.str_isfold`)
        }
        if (data.detail.IsHeju) {
          this1.iswinType = this1.$t(`lang.str_isheju`)
        }

        this1.Antes = (data.detail.AnteBet / 100).toFixed(2)
        this1.flop = (data.detail.FlopBet / 100).toFixed(2)
        this1.river = (data.detail.RiverBet / 100).toFixed(2)
        this1.turn = (data.detail.TurnBet / 100).toFixed(2)
        this1.jokerWin = (data.detail.Win / 100).toFixed(2)
        this1.BonusBet = (data.detail.BonusBet / 100).toFixed(2)
        this1.BonusWin = (data.detail.BonusWin / 100).toFixed(2)

        // 牌類型
        if (data.detail.BankerCardType == 1) {
          this1.bankerPokerType = this1.$t(`lang.str_card_type1`)
        } else if (data.detail.BankerCardType == 2) {
          this1.bankerPokerType = this1.$t(`lang.str_card_type2`)
        } else if (data.detail.BankerCardType == 3) {
          this1.bankerPokerType = this1.$t(`lang.str_card_type3`)
        } else if (data.detail.BankerCardType == 4) {
          this1.bankerPokerType = this1.$t(`lang.str_card_type4`)
        } else if (data.detail.BankerCardType == 5) {
          this1.bankerPokerType = this1.$t(`lang.str_card_type5`)
        } else if (data.detail.BankerCardType == 6) {
          this1.bankerPokerType = this1.$t(`lang.str_card_type6`)
        } else if (data.detail.BankerCardType == 7) {
          this1.bankerPokerType = this1.$t(`lang.str_card_type7`)
        } else if (data.detail.BankerCardType == 8) {
          this1.bankerPokerType = this1.$t(`lang.str_card_type8`)
        } else if (data.detail.BankerCardType == 9) {
          this1.bankerPokerType = this1.$t(`lang.str_card_type9`)
        } else if (data.detail.BankerCardType == 10) {
          this1.bankerPokerType = this1.$t(`lang.str_card_type10`)
        }
        //
        if (data.detail.CardType == 1) {
          this1.handlerPokerType = this1.$t(`lang.str_card_type1`)
        } else if (data.detail.CardType == 2) {
          this1.handlerPokerType = this1.$t(`lang.str_card_type2`)
        } else if (data.detail.CardType == 3) {
          this1.handlerPokerType = this1.$t(`lang.str_card_type3`)
        } else if (data.detail.CardType == 4) {
          this1.handlerPokerType = this1.$t(`lang.str_card_type4`)
        } else if (data.detail.CardType == 5) {
          this1.handlerPokerType = this1.$t(`lang.str_card_type5`)
        } else if (data.detail.CardType == 6) {
          this1.handlerPokerType = this1.$t(`lang.str_card_type6`)
        } else if (data.detail.CardType == 7) {
          this1.handlerPokerType = this1.$t(`lang.str_card_type7`)
        } else if (data.detail.CardType == 8) {
          this1.handlerPokerType = this1.$t(`lang.str_card_type8`)
        } else if (data.detail.CardType == 9) {
          this1.handlerPokerType = this1.$t(`lang.str_card_type9`)
        } else if (data.detail.CardType == 10) {
          this1.handlerPokerType = this1.$t(`lang.str_card_type10`)
        }
        this1.describe_title = this1.$t(`lang.str_2000_describe_title`)
        this1.describe_content = this1.$t(`lang.str_2000_describe_content`)
        this1.describe_message = this1.$t(`lang.str_2000_describe_message`)
        this1.winValueTotal = game_2000.getWinInfo(data.detail);
        this1.winValueTip = game_2000.getWinInfo(data.detail);
        if(this1.jokerWin >0 || this1.BonusWin >0)
        {
          this1.winValueTip = this1.$t(`lang.str_2000_win_value_tip`)
        }else
        {
          this1.winValueTip = this1.$t(`lang.str_2000_win_value_tip2`)
        }
      }

      if (data.gameId == 2001) {
        this1.bankerpoker = data.detail.BankerPokers
        this1.seatlist = data.detail.seats
        this1.bankerPokerPoint = data.detail.BankerPokerPoint
        this1.bankerPokerType = data.detail.BankerPokerType

        let WinInfo = game_2001.getWinInfo(this1,this1.seatlist);
        this1.winValueTotal = WinInfo[0];
        this1.winValueTip =  WinInfo[1];
        this1.describe_title = this1.$t(`lang.str_jokey2001_tip_message0`)
        this1.describe_content = this1.$t(`lang.str_jokey2001_tip_message1`)
        this1.describe_message = this1.$t(`lang.str_jokey2001_tip_message2`)

      }

      if (data.gameId == 2002||data.gameId == 2004) {
        this1.bankerpoker = data.detail.BankerPokers
        this1.bankerPokerPoint = data.detail.BankerPoint
        this1.handpoker = data.detail.PlayerPokers
        this1.handlerPokerPoint = data.detail.PlayerPoint
        this1.winpos = data.detail.WinPos
        this1.bets = data.detail.Bets
        this1.describe_title = this1.$t(`lang.str_jokey_tip_title`)
        if(data.gameId == 2004)
        {
          this1.winValueTip = this1.$t(`lang.str_jokey2004_tip_title`)
          this1.describe_message = this1.$t(`lang.str_jokey2004_tip_message`)
        }else{
          this1.winValueTip = this1.$t(`lang.str_jokey2002_tip_title`)
          this1.describe_message = this1.$t(`lang.str_jokey2002_tip_message`)
        }

        this1.winValueTotal = game_2002_2004.getWinInfo(this1.bets);
      }
      else if(data.gameId == 2005)
      {
        this1.gongniu_pokers = data.detail.GongniuPokers;
        this1.niuzai_pokers  = data.detail.NiuzaiPokers
        this1.common_pokers  = data.detail.CommonPokers;
        this1.gongniu_combine_pokers= data.detail.GongNiuCombinePokers;
        this1.niuzai_combine_pokers= data.detail.NiuZaiCombinePokers;
        this1.winPos  = data.detail.WinPos;
        this1.gongniuCardType  = data.detail.GongniuCardType;
        this1.niuzaiCardType  = data.detail.NiuzaiCardType;
        this1.bets = data.detail.Bets;
        this1.winValueTip = this1.$t(`lang.str_2005_win_value_tip`)
        this1.winValueTotal = game_2005.getWinInfo(this1.bets);
        this1.describe_title = this1.$t(`lang.str_jokey2005_tip_message0`)
        this1.describe_content = this1.$t(`lang.str_jokey2005_tip_message1`)
        this1.describe_message = this1.$t(`lang.str_jokey2005_tip_message2`)
      }

}
export {
  detail_by_token_joker
};



// WEBPACK FOOTER //
// ./src/components/data/detail_by_token_joker.js